"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var checkoutAPI_1 = tslib_1.__importDefault(require("./modules/checkoutAPI"));
var authorize_1 = require("./modules/authorize");
var cartAPI_1 = tslib_1.__importDefault(require("./modules/cartAPI"));
var methodOfPaymentAPI_1 = tslib_1.__importDefault(require("./modules/methodOfPaymentAPI"));
var logging_1 = tslib_1.__importDefault(require("./modules/logging"));
var pricingApi_1 = tslib_1.__importDefault(require("./modules/pricingApi"));
var addressValidationApi_1 = tslib_1.__importDefault(require("./modules/addressValidationApi"));
var couponAPI_1 = tslib_1.__importDefault(require("./modules/couponAPI"));
var newRelic_1 = tslib_1.__importDefault(require("./modules/newRelic"));
var checkoutUrlBuilderApi_1 = tslib_1.__importDefault(require("./modules/checkoutUrlBuilderApi"));
var client = {
    authorize: authorize_1.authorize,
    checkoutAPI: checkoutAPI_1.default,
    cartAPI: cartAPI_1.default,
    pricingApi: pricingApi_1.default,
    methodOfPaymentAPI: methodOfPaymentAPI_1.default,
    logging: logging_1.default,
    addressValidationApi: addressValidationApi_1.default,
    couponApi: couponAPI_1.default,
    newRelic: newRelic_1.default,
    checkoutUrlBuilderApi: checkoutUrlBuilderApi_1.default,
};
exports.default = client;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/client.js
// module id = 3346
// module chunks = 11